import { Ability } from "ember-can";

export default class TreatmentAbility extends Ability {
  get canEdit(): boolean {
    return true;
  }
}
